import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import useDocumentScrollThrottled from './UseDocumentScrollThrottled';

const Header = ({ context }) => {
    
    const ctxGlobal 		= () => context.global;
	const global 			= ctxGlobal();
	
	const ctxMenuOpen 		= () => context.menuOpen;
	const menuOpen 			= ctxMenuOpen();
	
	const ctxEnquireOpen 	= () => context.enquireOpen;
	const enquireOpen 		= ctxEnquireOpen();
	
	const ctxPageTitle 		= () => context.pageTitle;
	const pageTitle 		= ctxPageTitle();
	
	const ctxHeaderColor 	= () => context.headerColor;
	const headerColor 		= ctxHeaderColor();

	function handleMenuToggle(evt) {
	  	evt.preventDefault();
	  	context.toggleMenu();
  	}
  	
  	function handleEnquireToggle(evt) {
	  	evt.preventDefault();
	  	context.toggleEnquire();
  	}
			
    if (context.global) {
						
		if (global.json === null) {
			context.getGlobal(window.location.origin + '/wp-json/bastings/v1/global');
		}
		
		let _menuClass = '';
		let _menuText = 'Menu';
		if (menuOpen === true) {
			_menuClass = 'state-menu-open';
			_menuText = 'Close'
		}
		
		let _enquireClass = '';
		if (menuOpen === true) {
			_enquireClass = 'state-enquire-open';
		}
	  		  	
	  	if (global.json !== null) {  
		  	
			return (
				<>
					{headerColor === 'white' &&
						<a href="#" className={'c-header__enquire-button c-header__enquire-button--mobile ' + _enquireClass + ' ' + _enquireClass} onClick={handleEnquireToggle}>Enquire</a>
					}
					
			    	<header className={'c-header state-' + headerColor}>
						<h2 className="c-header__logo">
							<Link to={{ pathname: '/' }} className="c-header__logo__inner" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 7.8 2.4"><path style="fill:#FFFFFF;" d="M7.4,0.34C7.17,0.12,6.87,0,6.56,0C6.24-0.01,5.93,0.12,5.72,0.35C5.49,0.57,5.37,0.88,5.37,1.19 c0,0.31,0.12,0.61,0.33,0.84C5.92,2.27,6.23,2.41,6.55,2.4c0.31,0,0.62-0.12,0.84-0.34c0.25-0.22,0.38-0.54,0.37-0.88 C7.78,0.86,7.64,0.55,7.4,0.34z M2.88,2.28h2.17V0.11H2.88V2.28z M0.66,0.1L0.03,1.2l0.63,1.1h1.27l0.63-1.1L1.93,0.1H0.66z"/></svg>'}}></Link>
						</h2>
						<a href="#" className={'c-header__menu-button ' + _menuClass + ' ' + _enquireClass} onClick={handleMenuToggle}>{_menuText}</a>
						<a href="#" className={'c-header__enquire-button c-header__enquire-button--desktop ' + _enquireClass + ' ' + _enquireClass} onClick={handleEnquireToggle}>Enquire</a>
					</header>
					
					
					
					<div className={'c-mobile-menu scope-cream ' + _menuClass}>
						<div className="c-mobile-menu__inner">
							<h3 className="c-mobile-menu__title" dangerouslySetInnerHTML={{__html:pageTitle}}></h3>
							<div className="c-mobile-menu__spacer"></div>
							<ul className="c-mobile-menu__list">
								{global.json.pmenu.map((item,i) =>
									{										
										return (
											<li className="c-mobile-menu__list__item">
												{item.icon == 'square' &&
													<Link to={{ pathname: item.url }} className="c-mobile-menu__list__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><rect width="4" height="4"/></svg>' + item.title}}></Link>
												}
												
												{item.icon == 'circle' &&
													<Link to={{ pathname: item.url }} className="c-mobile-menu__list__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><circle cx="2" cy="2" r="2"/></svg>' + item.title}}></Link>
												}
												
												{item.icon == 'hexagon' &&
													<Link to={{ pathname: item.url }} className="c-mobile-menu__list__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><polygon points="3,0.3 1,0.3 0,2 1,3.7 3,3.7 4,2 "/></svg>' + item.title}}></Link>
												}
											</li>
										)
										
									}
								)}
							</ul>
							<ul className="c-mobile-menu__seclist">
								{global.json.smenu.map((item,i) =>
									{										
										return (
											<li className="c-mobile-menu__seclist__item">
												<Link to={{ pathname: item.url }} className="c-mobile-menu__seclist__link" dangerouslySetInnerHTML={{__html:item.title}}></Link>
											</li>
										)
									}
								)}
								<li className="c-mobile-menu__seclist__item">
									<a href="#" className="c-mobile-menu__seclist__link" dangerouslySetInnerHTML={{__html:"Enquiries"}} onClick={handleEnquireToggle}></a>
								</li>
								<li className="c-mobile-menu__seclist__item">
									<a href="#" className="c-mobile-menu__seclist__link" dangerouslySetInnerHTML={{__html:"Display Suite"}} onClick={handleEnquireToggle}></a>
								</li>
								{global.json.menu_instagram_url &&
									<li className="c-mobile-menu__seclist__item">
										<a href={global.json.menu_instagram_url} className="c-mobile-menu__seclist__link" target="_blank" dangerouslySetInnerHTML={{__html:"Instagram →"}}></a>
									</li>
								}
							</ul>
							<div className="c-mobile-menu__logos">
								<a className="c-mobile-menu__lucent" href="https://lucentgroup.com.au/" target="_blank" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 9.4 2.1"><path d="M7.91,0.19H7.57v0.4l-0.19,0.1v0.19h0.19v0.77c0,0.32,0.17,0.43,0.42,0.43C8.1,2.08,8.2,2.05,8.29,2 V1.73C8.23,1.76,8.16,1.78,8.09,1.78C8,1.79,7.92,1.73,7.9,1.64c0-0.02,0-0.03,0-0.05V0.88H8.3V0.59H7.91L7.91,0.19z M1.73,1.41 c0,0.23-0.14,0.36-0.33,0.36c-0.2,0-0.31-0.13-0.31-0.36V0.58H0.76v0.93c0,0.34,0.19,0.56,0.52,0.56c0.23,0,0.36-0.06,0.46-0.2 l0.1,0.17h0.24V0.58H1.73V1.41z M0,2.04h0.34V0.02H0V2.04z M4.71,0.55C4.29,0.55,4,0.89,4,1.31c-0.02,0.4,0.29,0.74,0.7,0.76 c0.02,0,0.03,0,0.05,0C4.98,2.08,5.2,1.98,5.34,1.8l-0.2-0.17C5.05,1.74,4.9,1.8,4.75,1.8c-0.22,0.01-0.4-0.16-0.42-0.37h1.07 c0-0.03,0.01-0.06,0.01-0.09C5.41,0.92,5.18,0.55,4.71,0.55z M4.33,1.21C4.36,0.98,4.5,0.82,4.71,0.82c0.22,0,0.35,0.17,0.37,0.38 H4.33z M3.18,1.79c-0.25,0-0.44-0.21-0.44-0.45c0-0.01,0-0.01,0-0.02C2.73,1.07,2.91,0.86,3.15,0.84c0,0,0.01,0,0.01,0 c0.15,0,0.29,0.07,0.38,0.18L3.75,0.8C3.61,0.63,3.39,0.54,3.17,0.55c-0.42,0-0.76,0.33-0.76,0.75c0,0.01,0,0.01,0,0.02 C2.4,1.73,2.73,2.07,3.14,2.08c0.01,0,0.01,0,0.02,0C3.4,2.08,3.62,1.98,3.76,1.8l-0.2-0.2C3.47,1.72,3.33,1.78,3.18,1.79z M9.23,0.19L9.11,0.38L8.98,0.19H8.91v0.4h0.07V0.3L9.1,0.49h0L9.23,0.3v0.29H9.3v-0.4H9.23z M8.51,0.25h0.13v0.34h0.07V0.25h0.13 V0.19H8.51L8.51,0.25z M6.58,0.55L6.58,0.55c-0.23,0-0.36,0.06-0.46,0.2l-0.1-0.17H5.79v1.46h0.34V1.22c0-0.23,0.14-0.36,0.33-0.36 c0.2,0,0.31,0.13,0.31,0.36v0.83H7.1V1.11C7.1,0.77,6.91,0.55,6.58,0.55z"/></svg>'}}></a>
							</div>
						</div>
						<a href="#" className={'c-header__menu-button ' + _menuClass} onClick={handleMenuToggle}>{_menuText}</a>
					</div>
					
					<a href="#" className={'c-desktop-menu__close ' + _menuClass} onClick={handleMenuToggle}></a>
					
					<div className={'c-desktop-menu scope-cream ' + _menuClass}>
						<div className="c-desktop-menu__inner">
							<div className="c-desktop-menu__spacer"></div>
							<ul className="c-desktop-menu__list">
								{global.json.pmenu.map((item,i) =>
									{										
										return (
											<li className="c-desktop-menu__list__item">
												{item.icon == 'square' &&
													<Link to={{ pathname: item.url }} className="c-desktop-menu__list__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><rect width="4" height="4"/></svg>' + item.title}}></Link>
												}
												
												{item.icon == 'circle' &&
													<Link to={{ pathname: item.url }} className="c-desktop-menu__list__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><circle cx="2" cy="2" r="2"/></svg>' + item.title}}></Link>
												}
												
												{item.icon == 'hexagon' &&
													<Link to={{ pathname: item.url }} className="c-desktop-menu__list__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><polygon points="3,0.3 1,0.3 0,2 1,3.7 3,3.7 4,2 "/></svg>' + item.title}}></Link>
												}
											</li>
										)
										
									}
								)}
							</ul>
							<div className="c-desktop-menu__bottom">
								<ul className="c-mobile-menu__seclist">
									{global.json.smenu.map((item,i) =>
										{										
											return (
												<li className="c-desktop-menu__seclist__item">
													<Link to={{ pathname: item.url }} className="c-desktop-menu__seclist__link" dangerouslySetInnerHTML={{__html:item.title}}></Link>
												</li>
											)
										}
									)}
								</ul>
								<div className="c-desktop-menu__text scope-text scope-text--footer" dangerouslySetInnerHTML={ {__html: global.json.menu_contact_details + '<p class="dark"><a href="' + global.json.menu_instagram_url + '" target="_blank" class="underline">Project instagram →</a></p>'}}></div>
								<div className="c-desktop-menu__logos">
									<a className="c-desktop-menu__lucent" href="https://lucentgroup.com.au/" target="_blank" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 9.4 2.1"><path d="M7.91,0.19H7.57v0.4l-0.19,0.1v0.19h0.19v0.77c0,0.32,0.17,0.43,0.42,0.43C8.1,2.08,8.2,2.05,8.29,2 V1.73C8.23,1.76,8.16,1.78,8.09,1.78C8,1.79,7.92,1.73,7.9,1.64c0-0.02,0-0.03,0-0.05V0.88H8.3V0.59H7.91L7.91,0.19z M1.73,1.41 c0,0.23-0.14,0.36-0.33,0.36c-0.2,0-0.31-0.13-0.31-0.36V0.58H0.76v0.93c0,0.34,0.19,0.56,0.52,0.56c0.23,0,0.36-0.06,0.46-0.2 l0.1,0.17h0.24V0.58H1.73V1.41z M0,2.04h0.34V0.02H0V2.04z M4.71,0.55C4.29,0.55,4,0.89,4,1.31c-0.02,0.4,0.29,0.74,0.7,0.76 c0.02,0,0.03,0,0.05,0C4.98,2.08,5.2,1.98,5.34,1.8l-0.2-0.17C5.05,1.74,4.9,1.8,4.75,1.8c-0.22,0.01-0.4-0.16-0.42-0.37h1.07 c0-0.03,0.01-0.06,0.01-0.09C5.41,0.92,5.18,0.55,4.71,0.55z M4.33,1.21C4.36,0.98,4.5,0.82,4.71,0.82c0.22,0,0.35,0.17,0.37,0.38 H4.33z M3.18,1.79c-0.25,0-0.44-0.21-0.44-0.45c0-0.01,0-0.01,0-0.02C2.73,1.07,2.91,0.86,3.15,0.84c0,0,0.01,0,0.01,0 c0.15,0,0.29,0.07,0.38,0.18L3.75,0.8C3.61,0.63,3.39,0.54,3.17,0.55c-0.42,0-0.76,0.33-0.76,0.75c0,0.01,0,0.01,0,0.02 C2.4,1.73,2.73,2.07,3.14,2.08c0.01,0,0.01,0,0.02,0C3.4,2.08,3.62,1.98,3.76,1.8l-0.2-0.2C3.47,1.72,3.33,1.78,3.18,1.79z M9.23,0.19L9.11,0.38L8.98,0.19H8.91v0.4h0.07V0.3L9.1,0.49h0L9.23,0.3v0.29H9.3v-0.4H9.23z M8.51,0.25h0.13v0.34h0.07V0.25h0.13 V0.19H8.51L8.51,0.25z M6.58,0.55L6.58,0.55c-0.23,0-0.36,0.06-0.46,0.2l-0.1-0.17H5.79v1.46h0.34V1.22c0-0.23,0.14-0.36,0.33-0.36 c0.2,0,0.31,0.13,0.31,0.36v0.83H7.1V1.11C7.1,0.77,6.91,0.55,6.58,0.55z"/></svg>'}}></a>
								</div>
							</div>
						</div>
						<a href="#" className={'c-header__menu-button ' + _menuClass} onClick={handleMenuToggle}>{_menuText}</a>
					</div>
				</>
			)
		
		} else {
			
			return null;
			
		}
		
	} else {
		
		return null;
		
	}
		
}
export default WithConsumer(Header);